export default "__VITE_ASSET__CUtpHqRH__"